import React from "react"
import { TwitterTweetEmbed } from "react-twitter-embed"
import Twitter from "react-sharingbuttons/dist/buttons/Twitter"
import { CarouselProvider, Slider, Slide, DotGroup } from "pure-react-carousel"
import ErrorBoundary from "../common/ErrorBoundary"

const TwitterFeedSection = () => {
  const height = 260

  const twitterRestyle = (tweetWidgetEl, height) => {
    let tweetEl = tweetWidgetEl.shadowRoot.querySelector(".Tweet-brand")
    tweetEl.style.display = "none"
    tweetEl = tweetWidgetEl.shadowRoot.querySelector(".CallToAction")
    tweetEl.style.display = "none"
    tweetEl = tweetWidgetEl.shadowRoot.querySelector(".TweetInfo")
    tweetEl.style.display = "none"
    tweetEl = tweetWidgetEl.shadowRoot.querySelector(".EmbeddedTweet")
    const boxShadow = "0px 4px 4px 0px rgba(0,0,0,0.1)"
    tweetEl.style["border-radius"] = "4px"
    tweetEl.style["box-shadow"] = boxShadow
    tweetEl.style["-moz-box-shadow"] = boxShadow
    tweetEl.style["-webkit-box-shadow"] = boxShadow
    tweetEl.style["font-family"] = "Sofia Pro Regular"
    if (height) tweetEl.style["height"] = `${height}px`
    tweetEl = tweetWidgetEl
    if (height) tweetEl.style["height"] = `${height}px`
    tweetEl = tweetWidgetEl.shadowRoot.querySelector(".SandboxRoot")
    if (height) tweetEl.style["height"] = `${height}px`
  }
  const twitterIds = [
    "1182077033784004609",
    "1179891436990455811",
    "1182076592824242176",
  ]
  return (
    <section className="flex flex-row flex-wrap text-white mb-4 md:mb-12 leading-normal pt-8 relative ">
      <div className="w-full max-w-about mx-auto px-content-mobile md:px-content">
        <div className="flex flex-col relative justify-center items-center w-full mb-2 lg:mr-3 ">
          <h2 className="font-heading uppercase text-center text-3xl text-black leading-tight">
            Tell the tech industry what it needs to change online. Share your
            voice. #DearSocialMedia
          </h2>
          <div className="mt-2">
            <Twitter
              text={"Tweet #DearSocialMedia"}
              shareText={"#DearSocialMedia"}
            />
          </div>
        </div>
      </div>

      <div className="w-full block md:hidden">
        <ErrorBoundary>
          <CarouselProvider totalSlides={twitterIds.length} className={"px-2"}>
            <Slider>
              {twitterIds.map((tweetId, index) => (
                <Slide index={index} key={index} style={{ height: "280px" }}>
                  <div className="w-full">
                    <div className="max-w-twitter-embed mx-auto">
                      <TwitterTweetEmbed
                        tweetId={tweetId}
                        options={{ hideThread: true }}
                        onLoaded={widget => twitterRestyle(widget, height)}
                        className="inline"
                      />
                    </div>
                  </div>
                </Slide>
              ))}
            </Slider>
            <DotGroup className="flex justify-center my-4"></DotGroup>
          </CarouselProvider>
        </ErrorBoundary>
      </div>
      <div className="w-full hidden md:block">
        <div className="flex content-center mx-auto w-full lg:max-w-about px-content-mobile md:px-content">
          <div className="w-1/3 pr-4 twitter-embed-wrap">
            <TwitterTweetEmbed
              tweetId={twitterIds[0]}
              options={{ hideThread: true }}
              onLoaded={widget => twitterRestyle(widget, height + 40)}
              className="inline"
            />
          </div>
          <div className="w-1/3 pr-4 twitter-embed-wrap">
            <TwitterTweetEmbed
              tweetId={twitterIds[1]}
              options={{ hideThread: true }}
              onLoaded={widget => twitterRestyle(widget, height + 40)}
            />
          </div>
          <div className="w-1/3 twitter-embed-wrap">
            <TwitterTweetEmbed
              tweetId={twitterIds[2]}
              options={{ hideThread: true }}
              onLoaded={widget => twitterRestyle(widget, height + 40)}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default TwitterFeedSection
